import {
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { API_URL } from "../constants/constants";
import { removeHash } from "../utils/hash";

// export const api = createApi({
//   reducerPath: "api",
//   baseQuery: async (args, api, extraOptions) => {
//     const baseQuery = fetchBaseQuery({
//       baseUrl: API_URL,
//       prepareHeaders: async (headers, { getState }) => {
//         const token = (getState() as any)?.auth?.access_token;

//         if (token) {
//           headers.set("Authorization", `Bearer ${token}`);
//         }

//         headers.set("ngrok-skip-browser-warning", "true");

//         return headers;
//       },
//     });

//     const result = await baseQuery(args, api, extraOptions);

//     // if (
//     //   result.error &&
//     //   result.error?.status === 401
//     //   // &&
//     //   // (result?.error?.data as any)?.message === "Unauthorized"
//     // ) {
//     //   localStorage.removeItem(AUTH_LOCALSTORAGE_NAME);
//     //   window.location.reload();
//     // }

//     return result;
//   },

//   endpoints: () => ({}),
// });

export const api = createApi({
  reducerPath: "api",
  baseQuery: async (args: string | FetchArgs, api, extraOptions) => {
    const rawBaseQuery = fetchBaseQuery({
      baseUrl: API_URL,
      prepareHeaders: (headers, { getState }) => {
        const token = (getState() as any).auth?.access_token;

        if (token) headers.set("Authorization", `Bearer ${token}`);

        headers.set("ngrok-skip-browser-warning", "true");
        return headers;
      },
    });

    const asObj: FetchArgs =
      typeof args === "string" ? { url: args } : { ...args };

    const productType = localStorage.getItem("product-type");
    const productId = productType ? removeHash(JSON.parse(productType)) : null;

    const dynamic = localStorage.getItem("dynamic");
    const dynamicData = dynamic ? JSON.parse(dynamic) : null;
    console.log({ dynamicData });
    console.log({ dID: removeHash("M+gSI8hyNyJvQHEIvB3YEA==") });

    const defaultParams = {
      productId,
      supplierKeyword: removeHash(dynamicData?.dynamicKeyword) || null,
      supplierId:
        removeHash(dynamicData?.dynamicId?.split(" ")?.join("+")) || null,
    };

    asObj.params = { ...defaultParams, ...(asObj.params ?? {}) };

    return rawBaseQuery(asObj, api, extraOptions);
  },

  /* endpoints can stay empty here and be injected elsewhere */
  endpoints: () => ({}),
});
